import React from 'react';
import PropTypes from 'prop-types';
import TableRow from './TableRow';
import TableHeader from './TableHeader';
import { observer } from 'mobx-react';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import Loader from './../loader/Loader';
import Icon from './../icon/Icon';

const propTypes = {
    tableType: PropTypes.string.isRequired,
};

@observer
class Table extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            tableCollapsed: false,
        };

        this.toggleTableCollapse = this.toggleTableCollapse.bind(this);
    }

    toggleTableCollapse () {
        this.setState({
            tableCollapsed: !this.state.tableCollapsed
        });
    }

    renderTableContent (data, tableType) {
        return data.length === 0 ? <Icon type='empty'/> : data.map((d, k) => {
            return (
                <TableRow key={(`${d.id || d.key}-${k}`)} index={k} rowData={d} tableType={tableType}/>
            );
        });
    }

    renderLoader () {
        return ( <Loader type='normal'/> );
    }

    renderError () {
        return (
            <Icon type='error'/>
        );
    }

    renderEmptyTable () {
        return (
            <Icon type='empty'/>
        );
    }

    render () {
        const {classes, data = [], status, tableType, tableMetadata, toggleFunc, toggleOn} = this.props;
        const {tableCollapsed} = this.state;

        const tableContentClasses = classNames({
            [classes.tableContents]: true,
            'expanded': !tableCollapsed
        });

        const showTableContent = data && data.length > 0 && typeof data === 'object';
        const showLoader = status === 'loading';
        const showError = status === 'error';
        const showEmptyTable = !showLoader && !showError && data && data.length === 0;

        return (
            <div className={classes.table}>
                <TableHeader onClick={this.toggleTableCollapse}
                             tableCollapsed={tableCollapsed}
                             toggleOn={toggleOn}
                             toggleFunc={toggleFunc}
                             tableMetadata={tableMetadata}
                             tableType={tableType}
                />
                <div className={classes.colorStrip}
                     style={{backgroundColor: `${( tableMetadata.colorPrimary || 'green' )}13`}}/>
                <div className={tableContentClasses}>
                    {showLoader && this.renderLoader()}
                    {showTableContent && this.renderTableContent(data, tableType)}
                    {showEmptyTable && this.renderEmptyTable()}
                    {showError && this.renderError()}
                </div>
            </div>
        );
    }
}

//*{data.length*/
// ? data.map((d, k) => {
//     return (
//         <TableRow key={k} index={k} rowData={d} tableType={tableType}/>
//     );
// })
// : <div className={classes.loader}>
//     <Loader loadStatus={loadStatus}/>
// </div>
// }

const styles = theme => ( {
    table: {
        ...theme.card,
        position: 'relative',
        width: theme.tables.width,
        // minWidth: theme.tables.minWidth,
        maxWidth: theme.tables.width,
        overflow: 'hidden',
        marginBottom: theme.spacing,
        [theme.devices.small]: {
            width: theme.tables.small.width,
            maxWidth: theme.tables.small.maxWidth,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
        [theme.devices.gtSmallSmMedium]: {
            width: theme.tables.large.width,
            maxWidth: theme.tables.large.width,
        },
    },
    tableContents: {
        maxHeight: theme.tables.maxHeight,
        minHeight: theme.tables.minHeight,
        height: '100%',
        overflowY: 'scroll',
        position: 'relative',
        transition: '.2s ease-in-out',
        [theme.devices.small]: {
            '&:not(.expanded)': {
                minHeight: theme.tables.small.notExpanded.minHeight,
                maxHeight: theme.tables.small.notExpanded.maxHeight,
                overflow: 'hidden'
            },
        }
    },
    colorStrip: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: 45,
        height: '100%'
    },
    loader: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: theme.spacing * 4,
        maxHeight: theme.tables.maxHeight,
        minHeight: theme.tables.minHeight,
    }
} );

Table.propTypes = propTypes;

export default injectSheet(styles)(Table);



// WEBPACK FOOTER //
// ./src/app/components/table/Table.js